import { getUIKitColorHSLA } from "@/helpers/style.helper.ts";
import useTimeOffHook from "@/hooks/use-time-off.hook.tsx";
import { TimeOffRequestExtendedProps } from "@/pages/time-off/TimeOffCalendar.tsx";
import { ApiApprovalRequestStatus } from "@/types/approvals/approval.types.ts";
import { EventContentArg } from "@fullcalendar/core";
import { EmojiDisplay, Stack, Text, toCssColorValue } from "@skailer-com/uikit";
import { twMerge } from "tailwind-merge";

export interface TimeOffCalendarCellProps {
  eventInfo: TimeOffCalendarEventInfo;
  clickable?: boolean;
}

export interface TimeOffCalendarEventInfo extends EventContentArg {
  extendedProps: TimeOffRequestExtendedProps;
}

export function TimeOffCalendarCell({ eventInfo, clickable = true }: TimeOffCalendarCellProps) {
  const request = (eventInfo.event.extendedProps as TimeOffRequestExtendedProps).request;
  const { openViewRequest } = useTimeOffHook();

  const isClickable = clickable && request?.acl?.can_view;

  return (
    <Stack
      className={twMerge("pt-4 -mb-1", isClickable ? "cursor-pointer" : "cursor-default")}
      onClick={() => {
        if (!isClickable) return;

        openViewRequest(Number(eventInfo.event.id));
      }}
    >
      <Stack
        style={{
          backgroundColor:
            request?.status === ApiApprovalRequestStatus.approved
              ? toCssColorValue(
                  request?.time_off_data.category.color,
                  getUIKitColorHSLA("dark", 0.8)
                )
              : "",
          borderColor:
            request?.status !== ApiApprovalRequestStatus.approved
              ? toCssColorValue(
                  request?.time_off_data.category.color,
                  getUIKitColorHSLA("dark", 0.8)
                )
              : "",
        }}
        className={twMerge(
          "rounded-xs py-1 px-2 leading-4",
          request?.status !== ApiApprovalRequestStatus.approved && "border-dashed border-2 py-0.5"
        )}
      >
        <Stack gap={"xs"} direction={"horizontal"}>
          {request?.time_off_data.category.emoji && (
            <EmojiDisplay id={request.time_off_data.category.emoji} size={"sm"} />
          )}
          <Text
            className={twMerge(
              "text-nowrap text-ellipsis  overflow-hidden",
              request?.status === ApiApprovalRequestStatus.approved
                ? "text-brand-light"
                : "text-dark"
            )}
          >
            {eventInfo.event.title}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
}
